import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../icon/icon';
import { hasBoards } from '../../../common/services/http/analysisContentService';

import './navigation.scss';

const Navigation: React.FC = () => {
  const [showBoards, setShowBoards] = useState(true);
  const svgContainerClass: string = `svg-container`;
  const svgContainerActiveClass: string = `svg-container-active`;
  const noPropagation = (e: any) => e.stopPropagation();

  useEffect(() => {
    hasBoards().then((r) => {
      setShowBoards(r.hasBoards);
    });
  }, []);

  return (
    <div className="navWrapper" onClick={noPropagation}>
      <NavLink end to="/" className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
        {({ isActive }) => (isActive ? <Icon name="fas fa-house-user" className="nav-icon" /> :
          <Icon name="far fa-house-user" className="nav-icon" />)}
      </NavLink>
      {showBoards && (
        <NavLink style={{ marginTop: 30 }} to="/boards"
                 className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
          {({ isActive }) => (isActive ? <Icon name="fas fa-chart-line" className="nav-icon" /> :
            <Icon name="far fa-chart-line" className="nav-icon" />)}
        </NavLink>
      )}

      <NavLink style={{ marginTop: 30 }} end to="/documents"
               className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>
        {({ isActive }) =>
          isActive ? <Icon name="fas fa-file-chart-line" className="nav-icon" /> :
            <Icon name="far fa-file-chart-line" className="nav-icon" />
        }
      </NavLink>

      {/*<NavLink style={{ marginTop: 30 }} end to="/investors" className={({ isActive }) => (isActive ? svgContainerActiveClass : svgContainerClass)}>*/}
      {/*  {({ isActive }) => (isActive ? <Icon name="fas fa-user-group" className="nav-icon" /> : <Icon name="far fa-user-group" className="nav-icon" />)}*/}
      {/*</NavLink>*/}
    </div>
  );
};

export default Navigation;
